import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import style from './style.module.css';
import { 
    setToken, setUuid, languages,
    setUserName, setLanguage,
    setMenuLabels, setMenuOpened, setCourseView, 
    languageParse, validLangs, enLang, setSystemLabels,
    incorrectUserOrPasswordLabel, 
    setOrganizations, setAppVersion, setActiveOrganization,
    Organizations, setOrganizationCount, setUserCount,
    setOrganization
  } from '../../utils/constants';

import { menuLabels, sysLabels } from '../../data/translations';
import Loader from '../../assets/images/loader.svg';
import { LoginAccount } from '../../services/authApi';
import { useNotification } from '../../utils/notifications';

const Login: React.FC = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const notify = useNotification()

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading,setIsLoading] = useState(true);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true)
    setIsLoggingIn(true)
    try {
      const response = await LoginAccount({username,password})
      if(response.token === 'false')
      {
          setIsLoggingIn(false)
          setIsLoading(false)

          notify(sysLabels[incorrectUserOrPasswordLabel]['EN'], 3000, '#FF0000')
          
          return;
      }

      setToken(response.token)
      setUuid(response.uuid)

      setUserName(response.firstname,response.lastname)

      setMenuOpened("true")
      setMenuLabels(JSON.stringify(menuLabels))
      setSystemLabels(JSON.stringify(sysLabels))

      setOrganizations(JSON.stringify(response.organization_list))
      setOrganization(JSON.stringify(response.organization))

      setOrganizationCount(response.organization_count)
      setUserCount(response.user_count)

      const orgList: Organizations = response.organization_list;
      const ownerOrg = orgList.find((org) => org.owner);
      if (ownerOrg) {
          setActiveOrganization(ownerOrg.id);
      } else if (orgList.length > 0) {
          setActiveOrganization(orgList[0].id);
      }

      setAppVersion(process.env.REACT_APP_VERSION || "0.0.0")

      const settings: string[] = response.settings;
      const langSetting = settings.find(item => validLangs.includes(item));
      const newLanguage = languages(languageParse(langSetting || enLang))
      setLanguage(JSON.stringify(newLanguage))
    
      navigate('/')

    } catch (error) 
    {
      setIsLoggingIn(false)
      setIsLoading(false)
    }
  };

  useEffect(() => {
    setTimeout(function(){
      setIsLoading(false)
    }, 1000);
  })

  useEffect(() => {
    setCourseView("false")
  }, [])

  return (
    <div className={style.wrapper}>
      <div className={style.container}>
        <div className={style.loginContainer}>
          <div className={style.logo}></div>
          <div className={style.adminText}>Admin</div>
          {
            isLoading || isLoggingIn ? 
              <div className={style.loader}>
                  <img src={Loader} />
              </div> :
              <>
                <input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className={style.loginInput}
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={style.loginInput}
                />
                <button
                  onClick={handleLogin}
                  disabled={isLoading}
                  className={style.loginButton}
                >
                  Login
                </button>
              </> 
          }   
        </div>
      </div>
    </div>
  );
};

export default Login;
